"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function valueToBool(a) {
    return !(a == false || a === 'false');
}
exports.default = valueToBool;
